





























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class ShareModal extends Vue {
  get shareModalOpen() {
    return this.$store.getters.shareModalOpen
  }
  set shareModalOpen(value) {
    this.$store.dispatch('setShareModal', value)
  }
  get facebookUrl(){
    return `https://www.facebook.com/sharer/sharer.php?u=${this.getUrl()}`
  }
  get whatsappUrl(){
    return this.isMobile()
      ? `whatsapp://send?text=${this.getUrl()}`
      : `https://web.whatsapp.com/send?text=${this.getUrl()}`
  }
  get facebookMessengerUrl(){
    return this.isMobile()
      ? `fb-messenger://share/?link=${this.getUrl()}&app_id=516530425068934`
      : `http://www.facebook.com/dialog/send?app_id=516530425068934&redirect_uri=${this.getUrl()}&link=${this.getUrl()}`
  }
  get telegramUrl(){
    return `https://telegram.me/share/url?url=${this.getUrl()}`
  }

  getUrl(){
    return encodeURIComponent(window.location.href)
  }

  isMobile() {
    if (
      navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ){
      return true;
    }
    else {
      return false;
    }
  }
}
